// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var NpsForm$ReactHooksTemplate = require("./NpsForm.res.js");
var CsatForm$ReactHooksTemplate = require("./csatForm.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var NpsEditor$ReactHooksTemplate = require("./NpsEditor.res.js");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var CsatEditor$ReactHooksTemplate = require("./csatEditor.res.js");
var NpsPreview$ReactHooksTemplate = require("./NpsPreview.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var CsatPreview$ReactHooksTemplate = require("./CsatPreview.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var DropDownForm$ReactHooksTemplate = require("./DropDownForm.res.js");
var LongTextForm$ReactHooksTemplate = require("./LongTextForm.res.js");
var MobileNumber$ReactHooksTemplate = require("./MobileNumber.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var ShortTextForm$ReactHooksTemplate = require("./ShortTextForm.res.js");
var DropDownEditor$ReactHooksTemplate = require("./DropDownEditor.res.js");
var LongTextEditor$ReactHooksTemplate = require("./LongTextEditor.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var StarRatingForm$ReactHooksTemplate = require("./StarRatingForm.res.js");
var DropDownPreview$ReactHooksTemplate = require("./DropDownPreview.res.js");
var LongTextPreview$ReactHooksTemplate = require("./LongTextPreview.res.js");
var RatingGroupForm$ReactHooksTemplate = require("./RatingGroupForm.res.js");
var ShortTextEditor$ReactHooksTemplate = require("./ShortTextEditor.res.js");
var MobileNumberForm$ReactHooksTemplate = require("./MobileNumberForm.res.js");
var OpinionScaleForm$ReactHooksTemplate = require("./OpinionScaleForm.res.js");
var ShortTextPreview$ReactHooksTemplate = require("./ShortTextPreview.res.js");
var SmileyRatingForm$ReactHooksTemplate = require("./SmileyRatingForm.res.js");
var StarRatingEditor$ReactHooksTemplate = require("./StarRatingEditor.res.js");
var RatingGroupEditor$ReactHooksTemplate = require("./RatingGroupEditor.res.js");
var StarRatingPreview$ReactHooksTemplate = require("./StarRatingPreview.res.js");
var MobileNumberEditor$ReactHooksTemplate = require("./MobileNumberEditor.res.js");
var MultipleChoiceForm$ReactHooksTemplate = require("./MultipleChoiceForm.res.js");
var MultipleSelectForm$ReactHooksTemplate = require("./MultipleSelectForm.res.js");
var OpinionScaleEditor$ReactHooksTemplate = require("./OpinionScaleEditor.res.js");
var RatingGroupPreview$ReactHooksTemplate = require("./RatingGroupPreview.res.js");
var SmileyRatingEditor$ReactHooksTemplate = require("./SmileyRatingEditor.res.js");
var MobileNumberPreview$ReactHooksTemplate = require("./MobileNumberPreview.res.js");
var OpinionScalePreview$ReactHooksTemplate = require("./OpinionScalePreview.res.js");
var SmileyRatingPreview$ReactHooksTemplate = require("./SmileyRatingPreview.res.js");
var MultipleChoiceEditor$ReactHooksTemplate = require("./MultipleChoiceEditor.res.js");
var MultipleSelectEditor$ReactHooksTemplate = require("./MultipleSelectEditor.res.js");
var MultipleChoicePreview$ReactHooksTemplate = require("./MultipleChoicePreview.res.js");
var MultipleSelectPreview$ReactHooksTemplate = require("./MultipleSelectPreview.res.js");

function id(t) {
  return t.id;
}

function position(t) {
  return t.position;
}

function uuid(t) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.uuid(opinionScale._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.uuid(opinionScale._0);
    case "LongText" :
        return LongText$ReactHooksTemplate.uuid(opinionScale._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.uuid(opinionScale._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.uuid(opinionScale._0);
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.uuid(opinionScale._0);
    case "RatingGroup" :
        return RatingGroup$ReactHooksTemplate.uuid(opinionScale._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.uuid(opinionScale._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.uuid(opinionScale._0);
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.uuid(opinionScale._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.uuid(opinionScale._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.uuid(opinionScale._0);
    
  }
}

function duplicate(q) {
  var x = q.questionType;
  var newQuestionType;
  switch (x.TAG) {
    case "OpinionScale" :
        newQuestionType = {
          TAG: "OpinionScale",
          _0: OpinionScale$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "StarRating" :
        newQuestionType = {
          TAG: "StarRating",
          _0: StarRating$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "LongText" :
        newQuestionType = {
          TAG: "LongText",
          _0: LongText$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "ShortText" :
        newQuestionType = {
          TAG: "ShortText",
          _0: ShortText$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "Nps" :
        newQuestionType = {
          TAG: "Nps",
          _0: Nps$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "MultipleChoice" :
        newQuestionType = {
          TAG: "MultipleChoice",
          _0: MultipleChoice$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "RatingGroup" :
        newQuestionType = {
          TAG: "RatingGroup",
          _0: RatingGroup$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "SmileyRating" :
        newQuestionType = {
          TAG: "SmileyRating",
          _0: SmileyRating$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "Csat" :
        newQuestionType = {
          TAG: "Csat",
          _0: Csat$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "MultipleSelect" :
        newQuestionType = {
          TAG: "MultipleSelect",
          _0: MultipleSelect$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "DropDown" :
        newQuestionType = {
          TAG: "DropDown",
          _0: DropDown$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    case "MobileNumber" :
        newQuestionType = {
          TAG: "MobileNumber",
          _0: MobileNumber$ReactHooksTemplate.duplicate(x._0)
        };
        break;
    
  }
  return {
          mandatory: q.mandatory,
          questionType: newQuestionType,
          id: undefined,
          position: q.position
        };
}

function text(t) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.text(opinionScale._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.text(opinionScale._0);
    case "LongText" :
        return LongText$ReactHooksTemplate.text(opinionScale._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.text(opinionScale._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.text(opinionScale._0);
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.text(opinionScale._0);
    case "RatingGroup" :
        return RatingGroup$ReactHooksTemplate.text(opinionScale._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.text(opinionScale._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.text(opinionScale._0);
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.text(opinionScale._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.text(opinionScale._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.text(opinionScale._0);
    
  }
}

function description(t) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.description(opinionScale._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.description(opinionScale._0);
    case "LongText" :
        return LongText$ReactHooksTemplate.description(opinionScale._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.description(opinionScale._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.description(opinionScale._0);
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.description(opinionScale._0);
    case "RatingGroup" :
        return RatingGroup$ReactHooksTemplate.description(opinionScale._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.description(opinionScale._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.description(opinionScale._0);
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.description(opinionScale._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.description(opinionScale._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.description(opinionScale._0);
    
  }
}

function categoryType(t) {
  var match = t.questionType;
  switch (match.TAG) {
    case "OpinionScale" :
        return "OpinionScale";
    case "StarRating" :
        return "StarRating";
    case "LongText" :
        return "LongText";
    case "ShortText" :
        return "ShortText";
    case "Nps" :
        return "Nps";
    case "MultipleChoice" :
        return "MultipleChoice";
    case "RatingGroup" :
        return "RatingGroup";
    case "SmileyRating" :
        return "SmileyRating";
    case "Csat" :
        return "Csat";
    case "MultipleSelect" :
        return "MultipleSelect";
    case "DropDown" :
        return "DropDown";
    case "MobileNumber" :
        return "MobileNumber";
    
  }
}

function questionType(t) {
  return t.questionType;
}

function mandatory(t) {
  return t.mandatory;
}

function setQuestionType(t, questionType) {
  return {
          mandatory: t.mandatory,
          questionType: questionType,
          id: t.id,
          position: t.position
        };
}

function setMandatory(t, mandatory) {
  return {
          mandatory: mandatory,
          questionType: t.questionType,
          id: t.id,
          position: t.position
        };
}

function setText(t, text) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return setQuestionType(t, {
                    TAG: "OpinionScale",
                    _0: OpinionScale$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "StarRating" :
        return setQuestionType(t, {
                    TAG: "StarRating",
                    _0: StarRating$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "LongText" :
        return setQuestionType(t, {
                    TAG: "LongText",
                    _0: LongText$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "ShortText" :
        return setQuestionType(t, {
                    TAG: "ShortText",
                    _0: ShortText$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "Nps" :
        return setQuestionType(t, {
                    TAG: "Nps",
                    _0: Nps$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "MultipleChoice" :
        return setQuestionType(t, {
                    TAG: "MultipleChoice",
                    _0: MultipleChoice$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "RatingGroup" :
        return setQuestionType(t, {
                    TAG: "RatingGroup",
                    _0: RatingGroup$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "SmileyRating" :
        return setQuestionType(t, {
                    TAG: "SmileyRating",
                    _0: SmileyRating$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "Csat" :
        return setQuestionType(t, {
                    TAG: "Csat",
                    _0: Csat$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "MultipleSelect" :
        return setQuestionType(t, {
                    TAG: "MultipleSelect",
                    _0: MultipleSelect$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "DropDown" :
        return setQuestionType(t, {
                    TAG: "DropDown",
                    _0: DropDown$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    case "MobileNumber" :
        return setQuestionType(t, {
                    TAG: "MobileNumber",
                    _0: MobileNumber$ReactHooksTemplate.setText(opinionScale._0, text)
                  });
    
  }
}

function setDescription(t, descriptionText) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return setQuestionType(t, {
                    TAG: "OpinionScale",
                    _0: OpinionScale$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "StarRating" :
        return setQuestionType(t, {
                    TAG: "StarRating",
                    _0: StarRating$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "LongText" :
        return setQuestionType(t, {
                    TAG: "LongText",
                    _0: LongText$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "ShortText" :
        return setQuestionType(t, {
                    TAG: "ShortText",
                    _0: ShortText$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "Nps" :
        return setQuestionType(t, {
                    TAG: "Nps",
                    _0: Nps$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "MultipleChoice" :
        return setQuestionType(t, {
                    TAG: "MultipleChoice",
                    _0: MultipleChoice$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "RatingGroup" :
        return setQuestionType(t, {
                    TAG: "RatingGroup",
                    _0: RatingGroup$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "SmileyRating" :
        return setQuestionType(t, {
                    TAG: "SmileyRating",
                    _0: SmileyRating$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "Csat" :
        return setQuestionType(t, {
                    TAG: "Csat",
                    _0: Csat$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "MultipleSelect" :
        return setQuestionType(t, {
                    TAG: "MultipleSelect",
                    _0: MultipleSelect$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "DropDown" :
        return setQuestionType(t, {
                    TAG: "DropDown",
                    _0: DropDown$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    case "MobileNumber" :
        return setQuestionType(t, {
                    TAG: "MobileNumber",
                    _0: MobileNumber$ReactHooksTemplate.setDescription(opinionScale._0, descriptionText)
                  });
    
  }
}

function answered(t) {
  var opinionScale = t.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.answered(opinionScale._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.answered(opinionScale._0);
    case "LongText" :
        return LongText$ReactHooksTemplate.answered(opinionScale._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.answered(opinionScale._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.answered(opinionScale._0);
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.answered(opinionScale._0);
    case "RatingGroup" :
        return RatingGroup$ReactHooksTemplate.answered(opinionScale._0, t.mandatory);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.answered(opinionScale._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.answered(opinionScale._0);
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.answered(opinionScale._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.answered(opinionScale._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.answered(opinionScale._0);
    
  }
}

function isValidAnswer(t) {
  var multipleSelect = t.questionType;
  if (multipleSelect.TAG === "MultipleSelect") {
    return MultipleSelect$ReactHooksTemplate.isSelectionValid(multipleSelect._0);
  } else {
    return true;
  }
}

function fromCategoryType(x) {
  var questionType = x === OpinionScale$ReactHooksTemplate.categoryType ? ({
        TAG: "OpinionScale",
        _0: OpinionScale$ReactHooksTemplate.empty()
      }) : (
      x === StarRating$ReactHooksTemplate.categoryType ? ({
            TAG: "StarRating",
            _0: StarRating$ReactHooksTemplate.empty()
          }) : (
          x === LongText$ReactHooksTemplate.categoryType ? ({
                TAG: "LongText",
                _0: LongText$ReactHooksTemplate.empty()
              }) : (
              x === ShortText$ReactHooksTemplate.categoryType ? ({
                    TAG: "ShortText",
                    _0: ShortText$ReactHooksTemplate.empty()
                  }) : (
                  x === Nps$ReactHooksTemplate.categoryType ? ({
                        TAG: "Nps",
                        _0: Nps$ReactHooksTemplate.empty()
                      }) : (
                      x === MultipleChoice$ReactHooksTemplate.categoryType ? ({
                            TAG: "MultipleChoice",
                            _0: MultipleChoice$ReactHooksTemplate.empty()
                          }) : (
                          x === RatingGroup$ReactHooksTemplate.categoryType ? ({
                                TAG: "RatingGroup",
                                _0: RatingGroup$ReactHooksTemplate.empty()
                              }) : (
                              x === SmileyRating$ReactHooksTemplate.categoryType ? ({
                                    TAG: "SmileyRating",
                                    _0: SmileyRating$ReactHooksTemplate.empty()
                                  }) : (
                                  x === Csat$ReactHooksTemplate.categoryType ? ({
                                        TAG: "Csat",
                                        _0: Csat$ReactHooksTemplate.empty()
                                      }) : (
                                      x === MultipleSelect$ReactHooksTemplate.categoryType ? ({
                                            TAG: "MultipleSelect",
                                            _0: MultipleSelect$ReactHooksTemplate.empty()
                                          }) : (
                                          x === DropDown$ReactHooksTemplate.categoryType ? ({
                                                TAG: "DropDown",
                                                _0: DropDown$ReactHooksTemplate.empty()
                                              }) : (
                                              x === MobileNumber$ReactHooksTemplate.categoryType ? ({
                                                    TAG: "MobileNumber",
                                                    _0: MobileNumber$ReactHooksTemplate.empty()
                                                  }) : undefined
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  if (questionType !== undefined) {
    return {
            mandatory: false,
            questionType: questionType,
            id: undefined,
            position: undefined
          };
  }
  
}

function empty(categoryType) {
  return Belt_Option.getExn(fromCategoryType(categoryType));
}

function toEditorBlock(f, question, quizMode) {
  var opinionScale = question.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return JsxRuntime.jsx(OpinionScaleEditor$ReactHooksTemplate.make, {
                    opinionScale: opinionScale._0,
                    onOpinionScaleChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "OpinionScale",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "StarRating" :
        return JsxRuntime.jsx(StarRatingEditor$ReactHooksTemplate.make, {
                    starRating: opinionScale._0,
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      }),
                    onStarRatingChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "StarRating",
                                  _0: x
                                }));
                      })
                  });
    case "LongText" :
        return JsxRuntime.jsx(LongTextEditor$ReactHooksTemplate.make, {
                    longText: opinionScale._0,
                    onLongTextChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "LongText",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "ShortText" :
        return JsxRuntime.jsx(ShortTextEditor$ReactHooksTemplate.make, {
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "Nps" :
        return JsxRuntime.jsx(NpsEditor$ReactHooksTemplate.make, {
                    nps: opinionScale._0,
                    mandatory: question.mandatory,
                    onNpsChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Nps",
                                  _0: x
                                }));
                      }),
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "MultipleChoice" :
        return JsxRuntime.jsx(MultipleChoiceEditor$ReactHooksTemplate.make, {
                    multipleChoice: opinionScale._0,
                    onMultipleChoiceChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleChoice",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "RatingGroup" :
        return JsxRuntime.jsx(RatingGroupEditor$ReactHooksTemplate.make, {
                    ratingGroup: opinionScale._0,
                    onRatingGroupChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "RatingGroup",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "SmileyRating" :
        return JsxRuntime.jsx(SmileyRatingEditor$ReactHooksTemplate.make, {
                    smileyRating: opinionScale._0,
                    onSmileyRatingChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "SmileyRating",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "Csat" :
        return JsxRuntime.jsx(CsatEditor$ReactHooksTemplate.make, {
                    csat: opinionScale._0,
                    onCsatChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Csat",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "MultipleSelect" :
        return JsxRuntime.jsx(MultipleSelectEditor$ReactHooksTemplate.make, {
                    quizMode: quizMode,
                    multipleSelect: opinionScale._0,
                    onMultipleChoiceChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleSelect",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "DropDown" :
        return JsxRuntime.jsx(DropDownEditor$ReactHooksTemplate.make, {
                    dropDown: opinionScale._0,
                    onDropDownChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "DropDown",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    case "MobileNumber" :
        return JsxRuntime.jsx(MobileNumberEditor$ReactHooksTemplate.make, {
                    mobileNumber: opinionScale._0,
                    onMobileNumberChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MobileNumber",
                                  _0: x
                                }));
                      }),
                    mandatory: question.mandatory,
                    onMandatoryChange: (function (x) {
                        Curry._1(f, setMandatory(question, x));
                      })
                  });
    
  }
}

function equals(lhs, rhs) {
  return Caml_obj.equal(uuid(lhs), uuid(rhs));
}

function toForm(f, customerInfo, surveyTheme, language, client, question, borderCss, substitutionVariables) {
  var opinionScale = question.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return JsxRuntime.jsx(OpinionScaleForm$ReactHooksTemplate.make, {
                    opinionScale: opinionScale._0,
                    customerInfo: customerInfo,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "OpinionScale",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "StarRating" :
        return JsxRuntime.jsx(StarRatingForm$ReactHooksTemplate.make, {
                    starRating: opinionScale._0,
                    surveyTheme: surveyTheme,
                    client: client,
                    mandatory: question.mandatory,
                    language: language,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "StarRating",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "LongText" :
        return JsxRuntime.jsx(LongTextForm$ReactHooksTemplate.make, {
                    longText: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "LongText",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "ShortText" :
        return JsxRuntime.jsx(ShortTextForm$ReactHooksTemplate.make, {
                    shortText: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "ShortText",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "Nps" :
        return JsxRuntime.jsx(NpsForm$ReactHooksTemplate.make, {
                    nps: opinionScale._0,
                    customerInfo: customerInfo,
                    surveyTheme: surveyTheme,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Nps",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "MultipleChoice" :
        return JsxRuntime.jsx(MultipleChoiceForm$ReactHooksTemplate.make, {
                    multipleChoice: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleChoice",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "RatingGroup" :
        return JsxRuntime.jsx(RatingGroupForm$ReactHooksTemplate.make, {
                    ratingGroup: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "RatingGroup",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "SmileyRating" :
        return JsxRuntime.jsx(SmileyRatingForm$ReactHooksTemplate.make, {
                    smileyRating: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "SmileyRating",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "Csat" :
        return JsxRuntime.jsx(CsatForm$ReactHooksTemplate.make, {
                    csat: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Csat",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "MultipleSelect" :
        return JsxRuntime.jsx(MultipleSelectForm$ReactHooksTemplate.make, {
                    multipleSelect: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleSelect",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "DropDown" :
        return JsxRuntime.jsx(DropDownForm$ReactHooksTemplate.make, {
                    dropDown: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "DropDown",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    case "MobileNumber" :
        return JsxRuntime.jsx(MobileNumberForm$ReactHooksTemplate.make, {
                    mobileNumber: opinionScale._0,
                    surveyTheme: surveyTheme,
                    language: language,
                    client: client,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MobileNumber",
                                  _0: x
                                }));
                      }),
                    borderCss: borderCss,
                    substitutionVariables: substitutionVariables
                  });
    
  }
}

function preview(f, customerInfo, surveyTheme, language, question, substitutionVariables, param) {
  var substitutionVariables$1 = Belt_Option.getWithDefault(substitutionVariables, {});
  var opinionScale = question.questionType;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        return JsxRuntime.jsx(OpinionScalePreview$ReactHooksTemplate.make, {
                    opinionScale: opinionScale._0,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "OpinionScale",
                                  _0: x
                                }));
                      })
                  });
    case "StarRating" :
        return JsxRuntime.jsx(StarRatingPreview$ReactHooksTemplate.make, {
                    starRating: opinionScale._0,
                    mandatory: question.mandatory,
                    language: language,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "StarRating",
                                  _0: x
                                }));
                      })
                  });
    case "LongText" :
        return JsxRuntime.jsx(LongTextPreview$ReactHooksTemplate.make, {
                    longText: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "LongText",
                                  _0: x
                                }));
                      })
                  });
    case "ShortText" :
        return JsxRuntime.jsx(ShortTextPreview$ReactHooksTemplate.make, {
                    shortText: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "ShortText",
                                  _0: x
                                }));
                      })
                  });
    case "Nps" :
        return JsxRuntime.jsx(NpsPreview$ReactHooksTemplate.make, {
                    nps: opinionScale._0,
                    customerInfo: customerInfo,
                    surveyTheme: surveyTheme,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Nps",
                                  _0: x
                                }));
                      }),
                    substitutionVariables: substitutionVariables$1
                  });
    case "MultipleChoice" :
        return JsxRuntime.jsx(MultipleChoicePreview$ReactHooksTemplate.make, {
                    multipleChoice: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleChoice",
                                  _0: x
                                }));
                      })
                  });
    case "RatingGroup" :
        return JsxRuntime.jsx(RatingGroupPreview$ReactHooksTemplate.make, {
                    ratingGroup: opinionScale._0,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "RatingGroup",
                                  _0: x
                                }));
                      })
                  });
    case "SmileyRating" :
        return JsxRuntime.jsx(SmileyRatingPreview$ReactHooksTemplate.make, {
                    smileyRating: opinionScale._0,
                    surveyTheme: surveyTheme,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "SmileyRating",
                                  _0: x
                                }));
                      })
                  });
    case "Csat" :
        return JsxRuntime.jsx(CsatPreview$ReactHooksTemplate.make, {
                    csat: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "Csat",
                                  _0: x
                                }));
                      })
                  });
    case "MultipleSelect" :
        return JsxRuntime.jsx(MultipleSelectPreview$ReactHooksTemplate.make, {
                    multipleSelect: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MultipleSelect",
                                  _0: x
                                }));
                      })
                  });
    case "DropDown" :
        return JsxRuntime.jsx(DropDownPreview$ReactHooksTemplate.make, {
                    dropDown: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "DropDown",
                                  _0: x
                                }));
                      })
                  });
    case "MobileNumber" :
        return JsxRuntime.jsx(MobileNumberPreview$ReactHooksTemplate.make, {
                    mobileNumber: opinionScale._0,
                    language: language,
                    mandatory: question.mandatory,
                    onChange: (function (x) {
                        Curry._1(f, setQuestionType(question, {
                                  TAG: "MobileNumber",
                                  _0: x
                                }));
                      })
                  });
    
  }
}

function toJson(withAnswerOpt, position, destroyOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var opinionScale = t.questionType;
  var questionTypeAttributes;
  switch (opinionScale.TAG) {
    case "OpinionScale" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            OpinionScale$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              OpinionScale$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "StarRating" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            StarRating$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              StarRating$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "LongText" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            LongText$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              LongText$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "ShortText" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            ShortText$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              ShortText$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "Nps" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            Nps$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              Nps$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "MultipleChoice" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            MultipleChoice$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              MultipleChoice$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "RatingGroup" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            RatingGroup$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              RatingGroup$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "SmileyRating" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            SmileyRating$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              SmileyRating$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "Csat" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            Csat$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              Csat$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "MultipleSelect" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            MultipleSelect$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              MultipleSelect$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "DropDown" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            DropDown$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              DropDown$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    case "MobileNumber" :
        questionTypeAttributes = {
          hd: [
            "category_type",
            MobileNumber$ReactHooksTemplate.categoryType
          ],
          tl: {
            hd: [
              "category_attributes",
              MobileNumber$ReactHooksTemplate.toJson(withAnswer, opinionScale._0)
            ],
            tl: /* [] */0
          }
        };
        break;
    
  }
  return Json_encode.object_({
              hd: [
                "mandatory",
                t.mandatory
              ],
              tl: {
                hd: [
                  "uid",
                  RandomId$ReactHooksTemplate.toJson(uuid(t))
                ],
                tl: {
                  hd: [
                    "id",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.id)
                  ],
                  tl: {
                    hd: [
                      "position",
                      position
                    ],
                    tl: {
                      hd: [
                        "_destroy",
                        destroy
                      ],
                      tl: questionTypeAttributes
                    }
                  }
                }
              }
            });
}

function decode(json) {
  var categoryType = Json_decode.field("category_type", Json_decode.string, json);
  var questionType = categoryType === OpinionScale$ReactHooksTemplate.categoryType ? ({
        TAG: "OpinionScale",
        _0: OpinionScale$ReactHooksTemplate.fromJson(json)
      }) : (
      categoryType === StarRating$ReactHooksTemplate.categoryType ? ({
            TAG: "StarRating",
            _0: StarRating$ReactHooksTemplate.fromJson(json)
          }) : (
          categoryType === LongText$ReactHooksTemplate.categoryType ? ({
                TAG: "LongText",
                _0: LongText$ReactHooksTemplate.fromJson(json)
              }) : (
              categoryType === ShortText$ReactHooksTemplate.categoryType ? ({
                    TAG: "ShortText",
                    _0: ShortText$ReactHooksTemplate.fromJson(json)
                  }) : (
                  categoryType === Nps$ReactHooksTemplate.categoryType ? ({
                        TAG: "Nps",
                        _0: Nps$ReactHooksTemplate.fromJson(json)
                      }) : (
                      categoryType === MultipleChoice$ReactHooksTemplate.categoryType ? ({
                            TAG: "MultipleChoice",
                            _0: MultipleChoice$ReactHooksTemplate.fromJson(json)
                          }) : (
                          categoryType === RatingGroup$ReactHooksTemplate.categoryType ? ({
                                TAG: "RatingGroup",
                                _0: RatingGroup$ReactHooksTemplate.fromJson(json)
                              }) : (
                              categoryType === SmileyRating$ReactHooksTemplate.categoryType ? ({
                                    TAG: "SmileyRating",
                                    _0: SmileyRating$ReactHooksTemplate.fromJson(json)
                                  }) : (
                                  categoryType === Csat$ReactHooksTemplate.categoryType ? ({
                                        TAG: "Csat",
                                        _0: Csat$ReactHooksTemplate.fromJson(json)
                                      }) : (
                                      categoryType === MultipleSelect$ReactHooksTemplate.categoryType ? ({
                                            TAG: "MultipleSelect",
                                            _0: MultipleSelect$ReactHooksTemplate.fromJson(json)
                                          }) : (
                                          categoryType === DropDown$ReactHooksTemplate.categoryType ? ({
                                                TAG: "DropDown",
                                                _0: DropDown$ReactHooksTemplate.fromJson(json)
                                              }) : (
                                              categoryType === MobileNumber$ReactHooksTemplate.categoryType ? ({
                                                    TAG: "MobileNumber",
                                                    _0: MobileNumber$ReactHooksTemplate.fromJson(json)
                                                  }) : undefined
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  if (questionType !== undefined) {
    return {
            mandatory: Json_decode.field("mandatory", Json_decode.bool, json),
            questionType: questionType,
            id: Json_decode.optional((function (param) {
                    return Json_decode.field("id", Json_decode.$$int, param);
                  }), json),
            position: Json_decode.optional((function (param) {
                    return Json_decode.field("position", Json_decode.$$int, param);
                  }), json)
          };
  }
  
}

function decodeQuestionPosition(json) {
  return [
          Json_decode.field("position", Json_decode.$$int, json),
          decode(json)
        ];
}

function fromJson(json) {
  var questions = Belt_List.map(Belt_List.keep(Belt_List.map(Belt_List.sort(Json_decode.field("questions", (function (param) {
                          return Json_decode.list(decodeQuestionPosition, param);
                        }), json), (function (param, param$1) {
                      return param[0] - param$1[0] | 0;
                    })), (function (param) {
                  return param[1];
                })), Belt_Option.isSome), Belt_Option.getExn);
  var decodeResponses = function (param) {
    var questionId = Json_decode.field("question_uid", RandomId$ReactHooksTemplate.fromJson, param);
    var question = List.find((function (x) {
            return Caml_obj.equal(uuid(x), questionId);
          }), questions);
    var opinionScale = question.questionType;
    switch (opinionScale.TAG) {
      case "OpinionScale" :
          var rating = Caml_format.float_of_string(Json_decode.field("response", (function (param) {
                      return Json_decode.field("rating", Json_decode.string, param);
                    }), param)) | 0;
          var opinionScale$1 = OpinionScale$ReactHooksTemplate.setAnswer(opinionScale._0, rating);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "OpinionScale",
                    _0: opinionScale$1
                  },
                  id: question.id,
                  position: question.position
                };
      case "StarRating" :
          var rating$1 = Caml_format.float_of_string(Json_decode.field("response", (function (param) {
                      return Json_decode.field("rating", Json_decode.string, param);
                    }), param)) | 0;
          var starRating = StarRating$ReactHooksTemplate.setAnswerInt(opinionScale._0, rating$1);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "StarRating",
                    _0: starRating
                  },
                  id: question.id,
                  position: question.position
                };
      case "LongText" :
          var answer = Json_decode.field("response", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), param);
          var longText = LongText$ReactHooksTemplate.setAnswer(opinionScale._0, answer);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "LongText",
                    _0: longText
                  },
                  id: question.id,
                  position: question.position
                };
      case "ShortText" :
          var answer$1 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), param);
          var shortText = ShortText$ReactHooksTemplate.setAnswer(opinionScale._0, answer$1);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "ShortText",
                    _0: shortText
                  },
                  id: question.id,
                  position: question.position
                };
      case "Nps" :
          var rating$2 = Caml_format.float_of_string(Json_decode.field("response", (function (param) {
                      return Json_decode.field("rating", Json_decode.string, param);
                    }), param)) | 0;
          var nps = Nps$ReactHooksTemplate.setAnswer(opinionScale._0, rating$2);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "Nps",
                    _0: nps
                  },
                  id: question.id,
                  position: question.position
                };
      case "MultipleChoice" :
          var choice = Json_decode.field("response", (function (param) {
                  return Json_decode.field("choice", Json_decode.string, param);
                }), param);
          var multipleChoice = MultipleChoice$ReactHooksTemplate.setAnswer(opinionScale._0, choice);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "MultipleChoice",
                    _0: multipleChoice
                  },
                  id: question.id,
                  position: question.position
                };
      case "RatingGroup" :
          var decodeSelections = function (json) {
            return [
                    Json_decode.field("id", Json_decode.string, json),
                    Json_decode.field("value", Json_decode.$$int, json)
                  ];
          };
          var answer$2 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("answer", (function (param) {
                                return Json_decode.list(decodeSelections, param);
                              }), param);
                }), param);
          var ratingGroup = List.fold_left(RatingGroup$ReactHooksTemplate.setAnswer, opinionScale._0, answer$2);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "RatingGroup",
                    _0: ratingGroup
                  },
                  id: question.id,
                  position: question.position
                };
      case "SmileyRating" :
          var smileyRating = opinionScale._0;
          var rating$3 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("rating", Json_decode.$$int, param);
                }), param);
          var ratingType = List.find((function (x) {
                  return SmileyRating$ReactHooksTemplate.ratingTypeToRating(x) === rating$3;
                }), SmileyRating$ReactHooksTemplate.ratingTypeCollection(smileyRating));
          var smileyRating$1 = SmileyRating$ReactHooksTemplate.setAnswer(smileyRating, ratingType);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "SmileyRating",
                    _0: smileyRating$1
                  },
                  id: question.id,
                  position: question.position
                };
      case "Csat" :
          var rating$4 = Caml_format.float_of_string(Json_decode.field("response", (function (param) {
                      return Json_decode.field("rating", Json_decode.string, param);
                    }), param)) | 0;
          var csat = Csat$ReactHooksTemplate.setAnswer(opinionScale._0, Csat$ReactHooksTemplate.ratingToAnswerType(rating$4));
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "Csat",
                    _0: csat
                  },
                  id: question.id,
                  position: question.position
                };
      case "MultipleSelect" :
          var decodeSelections$1 = function (json) {
            return {
                    id: Json_decode.field("id", RandomId$ReactHooksTemplate.fromJson, json),
                    text: Json_decode.field("label", Json_decode.string, json),
                    score: Json_decode.optional((function (param) {
                            return Json_decode.field("score", Json_decode.$$int, param);
                          }), json),
                    allowNonSpecifiedText: false,
                    notSpecifiedText: undefined
                  };
          };
          var answer$3 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("answer", (function (param) {
                                return Json_decode.list(decodeSelections$1, param);
                              }), param);
                }), param);
          var multipleSelect = List.fold_left(MultipleSelect$ReactHooksTemplate.setAnswer, opinionScale._0, answer$3);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "MultipleSelect",
                    _0: multipleSelect
                  },
                  id: question.id,
                  position: question.position
                };
      case "DropDown" :
          var decodeSelections$2 = function (json) {
            return {
                    id: Json_decode.field("id", RandomId$ReactHooksTemplate.fromJson, json),
                    text: Json_decode.field("label", Json_decode.string, json),
                    allowNonSpecifiedText: false,
                    notSpecifiedText: undefined
                  };
          };
          var answer$4 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("answer", (function (param) {
                                return Json_decode.list(decodeSelections$2, param);
                              }), param);
                }), param);
          var dropDown = List.fold_left(DropDown$ReactHooksTemplate.setAnswer, opinionScale._0, answer$4);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "DropDown",
                    _0: dropDown
                  },
                  id: question.id,
                  position: question.position
                };
      case "MobileNumber" :
          var answer$5 = Json_decode.field("response", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), param);
          var mobileNumber = MobileNumber$ReactHooksTemplate.setAnswer(opinionScale._0, answer$5);
          return {
                  mandatory: question.mandatory,
                  questionType: {
                    TAG: "MobileNumber",
                    _0: mobileNumber
                  },
                  id: question.id,
                  position: question.position
                };
      
    }
  };
  var respondedQuestions = Json_decode.withDefault(/* [] */0, (function (param) {
          return Json_decode.field("responses", (function (param) {
                        return Json_decode.list(decodeResponses, param);
                      }), param);
        }), json);
  return List.map((function (q) {
                var y = List.find_opt((function (x) {
                        return Caml_obj.equal(x.id, q.id);
                      }), respondedQuestions);
                if (y !== undefined) {
                  return y;
                } else {
                  return q;
                }
              }), questions);
}

exports.toEditorBlock = toEditorBlock;
exports.position = position;
exports.toForm = toForm;
exports.preview = preview;
exports.id = id;
exports.uuid = uuid;
exports.duplicate = duplicate;
exports.text = text;
exports.description = description;
exports.setText = setText;
exports.setDescription = setDescription;
exports.categoryType = categoryType;
exports.questionType = questionType;
exports.mandatory = mandatory;
exports.setQuestionType = setQuestionType;
exports.setMandatory = setMandatory;
exports.fromCategoryType = fromCategoryType;
exports.fromJson = fromJson;
exports.decode = decode;
exports.empty = empty;
exports.toJson = toJson;
exports.equals = equals;
exports.answered = answered;
exports.isValidAnswer = isValidAnswer;
/* react/jsx-runtime Not a pure module */
